import { RefObject, useCallback, useRef } from 'react';

import { VariantType } from '@/modules/models/VariantType';

import { ButtonsVariants, Colors, Dropdown } from './components';
import { Label, LabelText, OptionBlock, SelectedOption, VariantsInner, VariantsWrapper } from './Variants.styles';

interface VariantsProps {
  handle: string;
  bubbleRef: RefObject<HTMLDivElement | null>;
  selectedValues: (string | undefined)[];
  optionsList?: {
    labelText: string;
    type: VariantType | null;
    originalOptionName: string;
    values: string[];
    value?: string;
  }[];
  selectOption: (option: string, index: number) => void;
}

export const Variants = ({ handle, optionsList, selectOption, selectedValues, bubbleRef }: VariantsProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const getVariantComponent = useCallback(
    ({
      type,
      values,
      value,
      index,
    }: {
      handle: string;
      type: VariantType | null;
      values: string[];
      value?: string;
      index: number;
    }) => {
      switch (type) {
        case VariantType.COLOR:
          return <Colors handle={handle} value={value} index={index} values={values} selectOption={selectOption} />;

        case VariantType.BUTTON:
          return <ButtonsVariants value={value} index={index} values={values} selectOption={selectOption} />;

        case VariantType.DROPDOWN:
          return (
            <Dropdown bubbleRef={bubbleRef} value={value} index={index} values={values} selectOption={selectOption} />
          );

        default:
          return <ButtonsVariants value={value} index={index} values={values} selectOption={selectOption} />;
      }
    },
    [selectOption, bubbleRef, handle]
  );

  return (
    <VariantsWrapper>
      <VariantsInner>
        <div ref={contentRef}>
          {optionsList?.map(({ labelText, values, type, value }, index) => (
            <OptionBlock key={index}>
              <Label>
                <LabelText>{labelText}</LabelText>
                {selectedValues[index] && <div>—</div>}
                {selectedValues[index] && (
                  <SelectedOption title={selectedValues[index]}>{selectedValues[index]}</SelectedOption>
                )}
              </Label>
              {getVariantComponent({ type, values, index, value, handle })}
            </OptionBlock>
          ))}
        </div>
      </VariantsInner>
    </VariantsWrapper>
  );
};
